
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/[slug]/quote",
      function () {
        return require("private-next-pages/agents/[slug]/quote.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/[slug]/quote"])
      });
    }
  